export function about() {
    let aboutBtn = document.querySelector('[data-aboutBtn]');
    let aboutContainer = document.querySelector('[data-aboutContainer]');
    let mainContainer = document.querySelector('[data-mainNavContentWrapper]');

    function showMore() {
        aboutContainer.classList.add('_expanded');
        document.addEventListener('click', outsideAboutClickListener);
    }

    function hideMore() {
        aboutContainer.classList.remove('_expanded');
        document.removeEventListener('click', outsideAboutClickListener);
    }

    let outsideAboutClickListener = (evt) => {
        if (!mainContainer.contains(evt.target)) {
            hideMore();
        }
    }

    if (aboutBtn) {
        aboutBtn.addEventListener('click', showMore);
    }
}
